export interface OgiRetrieveRequest {
  quoteRef: string;
}

export interface OgiRetrieveResponse {
  /** Present while the granite OGI forwarder is still unimplemented. */
  message?: string;
  name?: string;
  quoteRef?: string;
  quoteNumber?: string;
  timestamp?: string;
  FurtherInfo?: unknown[];
  [key: string]: unknown;
}

/** Conditions that make an OGI quote unsafe to pull through automatically. */
export const OGI_EXCLUSIONS = [
  "Imported or modified vehicle",
  "More than 5 convictions",
  "More than 5 claims",
  "Any modification",
  "Any medical condition",
  "Any special query",
] as const;
